class TopWorks {
  constructor(selector) {
    this.root = document.querySelector(selector);
    if (!this.root) return;

    this.mq = window.matchMedia('(max-width: 767px)');
    if (this.mq.matches) return;

    this.items = [...this.root.querySelectorAll('.p-top__works-item')];
    this.panels = [...this.root.querySelectorAll('.p-top__works-panel')];
    this.duration = 450;
    this.isAnimating = false;
    this.activeIndex = this.items.findIndex((item) => item.classList.contains('is-active'));
    if (this.activeIndex < 0) this.activeIndex = 0;

    this.bind();
  }

  bind() {
    const prev = this.root.querySelector('.js-topWorksPrev');
    const next = this.root.querySelector('.js-topWorksNext');

    prev?.addEventListener('click', () => this.go(-1));
    next?.addEventListener('click', () => this.go(1));

    this.items.forEach((item, index) => {
      const trigger = item.querySelector('.p-top__works-item-btn');
      trigger?.addEventListener('click', () => {
        if (index !== this.activeIndex) this.goTo(index);
      });
    });
  }

  go(direction) {
    const length = this.items.length;
    const nextIndex = (this.activeIndex + direction + length) % length;
    this.goTo(nextIndex);
  }

  goTo(index) {
    if (this.isAnimating || index === this.activeIndex) return;

    this.isAnimating = true;
    const currentItem = this.items[this.activeIndex];
    const nextItem = this.items[index];
    const currentPanel = this.panels[this.activeIndex];
    const nextPanel = this.panels[index];

    currentItem.classList.remove('is-active');
    currentItem.classList.add('is-leaving');
    currentPanel.classList.remove('is-active');

    nextItem.classList.add('is-active', 'is-entering');
    nextPanel.classList.add('is-active');

    void nextItem.offsetWidth;

    window.setTimeout(() => {
      currentItem.classList.remove('is-leaving');
      nextItem.classList.remove('is-entering');
      this.activeIndex = index;
      this.isAnimating = false;
    }, this.duration);
  }
}
